import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ISerieSetup } from "src/models/General/SerieSetup.models";

interface serieSetupstate {
  serieSetups: ISerieSetup[];
  serieSetupToEdit: ISerieSetup | null;
}

const initialState: serieSetupstate = {
  serieSetups: [],
  serieSetupToEdit: null,
};

const serieSetupSlice = createSlice({
  name: "SerieSetup",
  initialState,
  reducers: {
    setSerieSetupList: (state, action: PayloadAction<ISerieSetup[]>) => {
      state.serieSetups = action.payload;
    },
    concatListSerieSetup: (
      state: serieSetupstate,
      action: PayloadAction<ISerieSetup[]>
    ) => {
      state.serieSetups = [...state.serieSetups.concat(action.payload)];
    },
    setSerieSetupToEdit: (state, action: PayloadAction<ISerieSetup | null>) => {
      state.serieSetupToEdit = action.payload;
    },
    addSerieSetup: (state, action: PayloadAction<ISerieSetup>) => {
      state.serieSetups.push(action.payload);
    },
    updateSerieSetup: (state, action: PayloadAction<ISerieSetup>) => {
      let itemIndex = state.serieSetups.findIndex(
        item => item.serieSetupId === action.payload.serieSetupId
      );
      if (itemIndex !== -1) state.serieSetups[itemIndex] = action.payload;
    },
    deleteSerieSetup: (state, action: PayloadAction<number>) => {
      const newArray = state.serieSetups.filter(
        item => item.serieSetupId !== action.payload
      );
      state.serieSetups = newArray;
    },
  },
});

export const {
  setSerieSetupList,
  concatListSerieSetup,
  setSerieSetupToEdit,
  addSerieSetup,
  updateSerieSetup,
  deleteSerieSetup,
} = serieSetupSlice.actions;

export default serieSetupSlice.reducer;
